export default {
    root: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        color: '{content.color}',
        borderRadius: '{content.border.radius}'
    },
    header: {
        background: 'transparent',
        color: '{text.color}',
        padding: '1.25rem',
        borderColor: '{content.border.color}',
        borderWidth: '0',
        borderRadius: '0'
    },
    toggleableHeader: {
        padding: '0.5rem 1.25rem'
    },
    title: {
        fontWeight: '600'
    },
    content: {
        padding: '0 1.25rem 1.25rem 1.25rem'
    },
    footer: {
        padding: '0 1.25rem 1.25rem 1.25rem'
    }
};
